export enum enumEsEditPageType {
  TRANSPORTATION_MODE,
  SHIPMENT_DATA,
  IMPORTER,
  BOND,
  BILL_OF_LADING,
  SHIPMENT_SELLER,
  SHIPMENT_CONSIGNEE,
  SHIPMENT_INVOICE,
  SHIPMENT_INVOICE_LINE,
  ATTACHED_DOCUMENTS,
  /** HTS_NOT_VERIFIED gate (#13384): resolved by the classification assistant's Validate view, not by a page. */
  HTS_VALIDATION,
}
